<template>
  <div class="pagination" v-if="totalPages > 1">
    <div class="pages">
      <vbutton class="left"
        v-if="currentPage !== 1"
        :label="$tr('common.list.previous')"
        :color="'white'"
        :disabled="loading"
        :loading="loading"
        @click="prevPage" />
      <!-- <li
        v-for="page in list"
        :class="{ active: currentPage === page, first: page === 1, last: page === list.length }"
        @click="changePage(page)"
      >
        {{ page }}
      </li> -->

      <div v-for="page in pages" :class="[page.selected ? activeClass : '', page.disabled ? disabledClass : '']">
        <a v-if="page.breakView" tabindex="0">...</a>
        <a v-else-if="page.disabled" tabindex="0">{{ page.content }}</a>
        <a class="asd" @click="changePage(page.index + 1)" v-else tabindex="0">{{ page.content }}</a>
      </div>

      <vbutton class="right"
        v-if="(currentPage) !== totalPages"
        :label="$tr('common.list.next')"
        :color="'white'"
        :disabled="loading"
        :loading="loading"
        @click="nextPage" />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'pagination',

    props: {
      params: Object,
      onPageChange: Function,
      // Limits Selector
      needSelector: Boolean,
      loading: Boolean,
      onLimitChange: Function,
      multiselectCssClass: String,
      limitsSelectorTitle: String,
      activeClass: {
        type: String,
        default: 'active'
      },
      disabledClass: {
        type: String,
        default: 'disabled'
      }
    },

    computed: {
      totalPages () {
        return this.params ? this.params.totalPages : 1
      },

      currentPage () {
        return this.params ? this.params.pageNumber : 1
      },

      list () {
        const arr = []
        const page = this.currentPage
        const totalPages = this.totalPages

        let leftBoundry = Math.max(1, page - 1)
        let rightBoundry = Math.min(totalPages, page + 1)

        const emptyRight = 1 - (rightBoundry - page)
        const emptyLeft = 1 - (page - leftBoundry)

        leftBoundry = Math.max(1, leftBoundry - emptyRight)
        rightBoundry = Math.min(totalPages, rightBoundry + emptyLeft)

        for (let i = leftBoundry; i <= rightBoundry; i++) {
          arr.push(i)
        }

        return arr
      },

      pages: function () {
        let items = {}
        const pageCount = this.totalPages;
        const pageRange = 3;
        const selected = this.currentPage;
        const marginPages = 1;

        if (pageCount <= pageRange) {
          for (let index = 0; index < pageCount; index++) {
            let page = {
              index: index,
              content: index + 1,
              selected: index === (selected - 1)
            }
            items[index] = page
          }
        } else {
          const halfPageRange = Math.floor(pageRange / 2)
          let setPageItem = index => {
            let page = {
              index: index,
              content: index + 1,
              selected: index === (selected - 1)
            }
            items[index] = page
          }
          let setBreakView = index => {
            let breakView = {
              disabled: true,
              breakView: true
            }
            items[index] = breakView
          }
          // 1st - loop thru low end of margin pages
          for (let i = 0; i < marginPages; i++) {
            setPageItem(i);
          }
          // 2nd - loop thru selected range
          let selectedRangeLow = 0;
          if (selected - halfPageRange > 0) {
            selectedRangeLow = selected - 1 - halfPageRange;
          }
          let selectedRangeHigh = selectedRangeLow + pageRange - 1;
          if (selectedRangeHigh >= pageCount) {
            selectedRangeHigh = pageCount - 1;
            selectedRangeLow = selectedRangeHigh - pageRange + 1;
          }
          for (let i = selectedRangeLow; i <= selectedRangeHigh && i <= pageCount - 1; i++) {
            setPageItem(i);
          }
          // Check if there is breakView in the left of selected range
          if (selectedRangeLow > marginPages) {
            setBreakView(selectedRangeLow - 1)
          }
          // Check if there is breakView in the right of selected range
          if (selectedRangeHigh + 1 < pageCount - marginPages) {
            setBreakView(selectedRangeHigh + 1)
          }
          // 3rd - loop thru high end of margin pages
          for (let i = pageCount - 1; i >= pageCount - marginPages; i--) {
            setPageItem(i);
          }
        }
        return items
      }
    },

    methods: {
      nextPage () {
        if (this.currentPage === this.totalPages) {
          return
        }
        this.changePage(this.currentPage + 1)
      },

      prevPage () {
        if (this.currentPage === 1) {
          return
        }
        this.changePage(this.currentPage - 1)
      },

      changePage (page) {
        this.onPageChange(page)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .pages {
    a {
      display: block;
      width: 100%;
      height: 100%;

      &:hover,
      &:focus,
      &:active {
        outline: none;
        color: inherit;
      }
    }
  }
</style>
